import React from 'react';
import { bool, object, string, func } from 'prop-types';

import CSS from './styles.css';

import Menu from './Menu';
import EBook from 'Components/EBook';
import Notebook from 'Components/Notebook';

const ReaderViews = ({
    activeMenu,
    createPageViewerFail,
    isLoading,
    toggle,
    showPageSelector
  }) => {
  return (
    <div className={ CSS['container'] }>
      <Menu
        isLoading={ isLoading }
        isDisabled={ createPageViewerFail }
        activeMenu={ activeMenu }
        showPageSelector={ showPageSelector }
        parentToggle={ toggle }
      />

      <EBook isShown={ activeMenu === 'eBOOK' } />
      <Notebook isShown={ activeMenu !== 'eBOOK'} />
      
    </div>
  );
};

ReaderViews.propTypes = {
  activeMenu: string,
  createPageViewerFail: bool,
  isLoading: bool,
  toggle: func,
  showPageSelector: bool
};


export default ReaderViews;
